module.exports = __webpack_public_path__ + "img/vp-play.866881f7.svg";